import { FormAssemblySubmit } from 'js/utils/FormAssemblySubmit';

/**
 * Component for Form Assembly component.
 */
export default class FormAssembly {
  /**
   * Start the component.
   */
  constructor({ element, children, options }) {
    this.element = element;
    this.children = children;
    this.options = options;

    // Bind class methods.
    this.init = this.init.bind(this);

    this.init();
  }

  /**
   * Initialize a FormAssemblySubmit instance.
   */
  init() {
    this.formAssemblySubmit = new FormAssemblySubmit(this.element);
  }
}
